(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["inntil-storrelsesnavn"] && !Shopify.designMode) return;
  try {
    (function () {
    var kilde = document.querySelector('[data-inntil-storrelsesnavn]');
    if (!kilde) return;

    /* «S=SMALL, M=MEDIUM» -> { s: 'SMALL', m: 'MEDIUM' }.
       Nøklene settes i små bokstaver, så oppslaget tåler at noen skriver
       «s=small» i editoren. */
    var kart = {};
    try {
      JSON.parse(kilde.textContent).split(',').forEach(function (par) {
        var deler = par.split('=');
        if (deler.length !== 2) return;
        var fra = deler[0].trim().toLowerCase();
        var til = deler[1].trim();
        if (fra && til) kart[fra] = til;
      });
    } catch (e) {
      return;
    }

    function skrivUt() {
      var felt = document.querySelector('.sticky-add-to-cart__variant');
      if (!felt) return;

      /* Originalen huskes, ellers ville en oversettelse bli oversatt på nytt
         når varianten endres og teksten allerede står utskrevet. */
      if (!felt.dataset.inntilOriginal) {
        felt.dataset.inntilOriginal = felt.textContent.trim();
      }
      var kort = felt.dataset.inntilOriginal;
      var naa = felt.textContent.trim();
      if (naa && naa !== kort && !kart[naa.toLowerCase()]) {
        felt.dataset.inntilOriginal = naa;
        kort = naa;
      }

      var lang = kart[kort.toLowerCase()];
      if (lang && felt.textContent.trim() !== lang) felt.textContent = lang;
    }

    skrivUt();

    /* Teksten settes av temaets eget skript når kunden bytter størrelse, så
       vi må skrive om igjen etterpå. En observer er tryggere enn å lytte på
       variantvelgeren, som har flere innganger: knapper, tastatur og URL. */
    var felt = document.querySelector('.sticky-add-to-cart__variant');
    if (!felt || !('MutationObserver' in window)) return;

    var vakt = new MutationObserver(function () {
      vakt.disconnect();
      skrivUt();
      vakt.observe(felt, { childList: true, characterData: true, subtree: true });
    });
    vakt.observe(felt, { childList: true, characterData: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
